let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("3yAl4"), load("76n7a"), load("l253H"), load("ffQaD"), load("kvRbA"), load("kNFvF"), load("lG0h2")]).then(() => parcelRequire('3twM3'));